import { createClient } from "contentful";
import { isDev, isLocal, isStage } from "../env";

const space = "e2pno9od1b6a";
const publishedAccessToken = "rwd_sVmaUxFPa5GPWaxJ7kFFoun597ps_g5VZ3KoIWg";
const publishedHost = "cdn.contentful.com";
const draftAccessToken = "FSwnJQ5z2-hAytCQZynTiK9I6OcpmbXTM-BbKzZHwKk";
const draftHost = "preview.contentful.com";

// NOTE: this token is not secret, it's read only to consume data
// Token that returns only PUBLISHED content
let contentfulSettings = {
  accessToken: publishedAccessToken,
  host: publishedHost,
  environment: "master",
};

// Token that returns both DRAFT and PUBLISHED content + STAGE Environment
if (isStage()) {
  contentfulSettings = {
    accessToken: draftAccessToken,
    host: draftHost,
    environment: "stage",
  };
}

// Token that returns both DRAFT and PUBLISHED content + DEV Environment
if (isDev() || isLocal()) {
  contentfulSettings = {
    accessToken: draftAccessToken,
    host: draftHost,
    environment: "dev",
  };
}

export const contentfulClient = createClient({
  space,
  ...contentfulSettings,
});
